import { render } from "./ToolVue.vue?vue&type=template&id=4b82c08d"
import script from "./ToolVue.vue?vue&type=script&lang=js"
export * from "./ToolVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__